module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_figure_2ade847fc33e6c4a83286c187e7cf98e.png";